var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGiftCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7146_27287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.65 23.77H3.35C1.5 23.77 0 22.27 0 20.42V3.58001C0 1.73001 1.5 0.230011 3.35 0.230011H28.65C30.5 0.230011 32 1.73001 32 3.58001V20.42C32 22.27 30.5 23.77 28.65 23.77ZM3.35 1.88001C2.41 1.88001 1.65 2.64001 1.65 3.58001V20.42C1.65 21.36 2.41 22.12 3.35 22.12H28.65C29.59 22.12 30.35 21.36 30.35 20.42V3.58001C30.35 2.64001 29.59 1.88001 28.65 1.88001H3.35Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.96 11.05H11.5L17.67 5.18C18.33 4.58 19.11 4.28 19.97 4.28C21.84 4.28 23.35 5.8 23.35 7.66C23.35 9.52 21.83 11.04 19.97 11.04L19.96 11.05ZM15.61 9.41H19.96C20.92 9.41 21.7 8.63 21.7 7.67C21.7 6.71 20.92 5.93 19.96 5.93C19.52 5.93 19.13 6.08 18.81 6.37L15.61 9.41Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.82 11.05H6.34997C4.47997 11.05 2.96997 9.53001 2.96997 7.67001C2.96997 5.81001 4.48997 4.29001 6.34997 4.29001C7.19997 4.29001 7.98997 4.59001 8.60997 5.16001L14.81 11.06L14.82 11.05ZM6.34997 5.93001C5.38997 5.93001 4.60997 6.71001 4.60997 7.67001C4.60997 8.63001 5.38997 9.41001 6.34997 9.41001H10.7L7.50997 6.38001C7.17997 6.08001 6.78997 5.93001 6.34997 5.93001Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6388 10.7414L5.90826 16.2699L6.95557 17.5449L13.6861 12.0164L12.6388 10.7414Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6776 10.7371L12.6303 12.0121L19.3608 17.5406L20.4081 16.2656L13.6776 10.7371Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.18 9.48999H0.820007V11.13H31.18V9.48999Z",
    fill: "#1D2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.98 0.570007H12.34V22.95H13.98V0.570007Z",
    fill: "#1D2939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7146_27287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGiftCard);
export default __webpack_public_path__ + "static/media/IconGiftCard.946ea8e3.svg";
export { ForwardRef as ReactComponent };